import { gql } from "@apollo/client";

export const GetMrfsForRFQs = gql`
  query GetMrfsForRFQs(
    $token: String!
    $after: Cursor
    $first: Int
    $finYrId: ID!
    $customerId: ID!
    $start_date: Time!
    $end_date: Time!
    $orderBy: AtsMrfMstOrder
    $queryType: MrfQueryType!
    $name: String
  ) {
    GetMrfs(
      token: $token
      after: $after
      first: $first
      finYrId: $finYrId
      customerId: $customerId
      orderBy: $orderBy
      queryType: $queryType
      start_date: $start_date
      end_date: $end_date
      where: { or: [{ mrfNoContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          mrfNo
          mrfDate
          subsidiary {
            id
            name
          }
          rfqPendingItems {
            id
            udfItemDesc
            uom
            presentStk
            approxRate
            acceptQty
            taxable
            tax
            trnNeedBefore
            priority
            item {
              id
              desc
              code
            }
          }
          raisedByUserDetails {
            name
          }
          acceptedByUserDetails {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetRfqs = gql`
  query GetRfqs(
    $token: String!
    $after: Cursor
    $start_date: Time!
    $end_date: Time!
    $first: Int
    $finYrId: ID!
    $customerId: ID!
    $orderBy: AtsRfqMstOrder
    $queryType: RfqQueryType!
    $name: String
  ) {
    GetRfqs(
      token: $token
      after: $after
      first: $first
      finYrId: $finYrId
      customerId: $customerId
      orderBy: $orderBy
      start_date: $start_date
      end_date: $end_date
      queryType: $queryType
      where: { or: [{ rfqNoContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          rfqNo
          rfqDate
          remarks
          lastDateRfqSubmission
          comprMadeDate
          raisedByUserID
          comprRemarks
          completed
          comprMadeByID
          rfqTrnDetails {
            id
            slNo
            trnQty
            approxRate
            udfItemDesc
            item {
              id
              uom
            }
            mrf_trn_details {
              approxDlvryRate
              approxInstRate
              approxOtherRate
              tax
            }
          }
          raisedUserDetails {
            id
            name
          }
          comprUserDetails {
            id
            name
          }
          negoUserDetails {
            id
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetRfqByNode = gql`
  query GetRfqByNode($token: String!, $id: ID!) {
    node(id: $id, token: $token) {
      id
      ... on AtsRfqMst {
        rfqNo
        rfqDate
        remarks
        lastDateRfqSubmission
        rfqTrnDetails {
          id
          itemTerms
          udfItemDesc
          itemPaymentTerms
          itemRemarks
          preferedSupplierDetails {
            id
            desc
          }
          mrf_trn_details {
            id
            udfItemDesc
            presentStk
            approxRate
            acceptQty
            taxable
            tax
            priority
            trnNeedBefore
            mrf {
              id
              mrfNo
              mrfDate
              subsidiary {
                id
                name
              }
            }
            item {
              id
              desc
              code
              uom
            }
          }
        }
      }
    }
  }
`;

export const GetRfqTrnSupply = gql`
  query GetRfqTrnSupply($rfqTrnID: ID!, $ldgrID: ID!) {
    GetRfqTrnSupply(rfqTrnID: $rfqTrnID, ldgrID: $ldgrID) {
      id
      rfq {
        lastDateRfqSubmission
        rfqNo
        remarks
        generalTerms
        generalPaymentTerms
      }
      rfqTrn {
        udfItemDesc
        itemTerms
        itemPaymentTerms
        mrf_trn_details {
          reqQty
          remarks
        }
        preferedSupplierDetails {
          id
          desc
          supplier_details {
            city
            gstNo
            panNo
          }
        }
      }
      supplierDetails {
        id
        desc
        supplier_details {
          city
          gstNo
        }
      }
    }
  }
`;

export const GetRfqTrnsForFillQuotation = gql`
  query GetRfqTrnsFromSupplierId(
    $token: String!
    $after: Cursor
    $rfqID: ID!
    $supplierId: ID!
    $queryType: RfqTrnQueryType!
    $first: Int
    $orderBy: AtsRfqTrnOrder
    $name: String
  ) {
    GetRfqTrnsFromSupplierId(
      token: $token
      after: $after
      rfqID: $rfqID
      supplierId: $supplierId
      queryType: $queryType
      first: $first
      orderBy: $orderBy
      where: { or: [{ udfItemDescContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          udfItemDesc
          mrf_trn_details {
            reqQty
          }
          itemTerms
          itemPaymentTerms
          rfq {
            lastDateRfqSubmission
            rfqNo
            remarks
          }
          preferedSupplierDetails {
            id
            supplier_details {
              id
              gstNo
              panNo
              city
              supplier_name {
                desc
              }
            }
          }
          itemRemarks
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetRfqTrnSupplyByKey = gql`
  query GetRfqTrnSupplyByKey($key: String!) {
    GetRfqTrnSupplyByKey(key: $key) {
      id
      itemDescChanged
      isAccepted
      quotedDesc
      quotedQty
      quotedRate
      quotedAnyChanges
      quotedTax
      quotedDelvChrg
      quotedInstChrg
      quotedValue
      quotedRemarks
      quotedOther
      quotedCompleted
      rfq {
        lastDateRfqSubmission
        rfqNo
        remarks
        generalTerms
        generalPaymentTerms
      }
      ldgrID
      rfqTrn {
        id
        udfItemDesc
        itemTerms
        itemPaymentTerms
        mrf_trn_details {
          reqQty
          remarks
        }
        preferedSupplierDetails {
          id
          desc
          supplier_details {
            city
            gstNo
            panNo
          }
        }
      }
      supplierDetails {
        id
        desc
        supplier_details {
          city
          gstNo
          panNo
        }
      }
    }
  }
`;

export const GetRfqTrnSupplyByKeyForQuotationDetails = gql`
  query GetRfqTrnSupplyByKeyForQuotationDetails($key: String!) {
    GetRfqTrnSupplyByKey(key: $key) {
      id
      itemDescChanged
      isAccepted
      quotedDesc
      quotedQty
      quotedRate
      quotedAnyChanges
      quotedTax
      quotedDelvChrg
      quotedInstChrg
      quotedValue
      quotedRemarks
      quotedOther
      rfq {
        lastDateRfqSubmission
        rfqNo
        remarks
        generalTerms
        generalPaymentTerms
      }
      ldgrID
      rfqTrn {
        id
        udfItemDesc
        itemTerms
        itemPaymentTerms
        mrf_trn_details {
          reqQty
          remarks
        }
        preferedSupplierDetails {
          id
          desc
          supplier_details {
            city
            gstNo
            panNo
          }
        }
      }
      supplierDetails {
        id
        desc
        supplier_details {
          city
          gstNo
          panNo
        }
      }
    }
  }
`;

export const CheckIfQuoteSubmitted = gql`
  query CheckIfQuoteSubmitted($key: String!) {
    CheckIfQuoteSubmitted(key: $key)
  }
`;
